"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BilledFrom = void 0;
var BilledFrom;
(function (BilledFrom) {
    BilledFrom["DOMESTIC"] = "domestic";
    BilledFrom["OVERSEAS"] = "overseas";
})(BilledFrom = exports.BilledFrom || (exports.BilledFrom = {}));
